import React from 'react';
import { Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowDownLong,
  faPlayCircle,
} from '@fortawesome/free-solid-svg-icons';
import Avatar from 'src/components/base/Avatar/Avatar';
import { Typography } from 'src/latest/src/components';
import { getMeetingAvailabilityGradient } from '../CATherapistList.utils';
import acceptInsurance from '../../../../assets/icons/icon-inNetwork.svg';
import AvailableSlots from '../AvailableSlots/AvailableSlots';
import Tooltip from '../../../base/Tooltip/Tooltip';
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from 'react-circular-progressbar';
import './TherapistListCard.scss';
import moment from 'moment';
import GroupIcon from 'src/assets/icons/GroupIcon.svg';

type Props = {
  index: number,
  profileRedirection: Function,
  therapistInfo?: any,
  expandAvailability: number,
  cardExpand: number,
  handleAvailability: Function,
  moreVisible: any,
  handleFlipCard: Function,
  bookAppointmentSlot: Function,
  statusLoading: boolean,
  statusLoadingElement: any,
  practiceTimeZone: string,
  isClinicianAvailabilityPage: boolean,
  handleLaterSlot: Function,
};

export default function TherapistListCard({
  index,
  profileRedirection,
  therapistInfo,
  expandAvailability,
  cardExpand,
  handleAvailability,
  moreVisible,
  handleFlipCard,
  bookAppointmentSlot,
  statusLoading,
  statusLoadingElement,
  practiceTimeZone,
  isClinicianAvailabilityPage,
  handleLaterSlot,
}: Props): ReactElement<any> {
  return (
    <div className="therapists-listCA__item">
      <div
        onClick={() =>
          profileRedirection(
            therapistInfo.therapist_id,
            therapistInfo?.slugify_name,
          )
        }
      >
        <Avatar
          linear={therapistInfo?.linear}
          fullName={
            therapistInfo?.therapist_name?.trim() ||
            therapistInfo?.therapist_email
          }
          photoUrl={therapistInfo?.profile_picture}
          className="therapists-listCA__item-avatar cursor-pointer"
          size="120px"
        />
      </div>
      <div
        className={`therapists-listCA__item-info ${
          expandAvailability === index ? 'custom-height' : ''
        }`}
      >
        <div className="d-flex justify-content-between ">
          <div
            className="therapists-listCA__item-info__name d-flex mb-1 ms-3"
            onClick={() =>
              profileRedirection(
                therapistInfo.therapist_id,
                therapistInfo?.slugify_name,
              )
            }
          >
            <Tooltip
              text={therapistInfo?.therapist_name}
              placement="right"
              // force={false}
            >
              <Typography
                variant="size-20"
                className="me-3 cursor-pointer"
                weight="bold"
              >
                {therapistInfo?.therapist_name?.trim().length > 21
                  ? `${therapistInfo?.therapist_name
                      .trim()
                      .substring(0, 18)}...`
                  : therapistInfo?.therapist_name?.trim() ||
                    therapistInfo?.therapist_email}
              </Typography>
            </Tooltip>
            <Typography
              variant="size-12"
              color="color-4"
              weight="bold"
              className="therapists-listCA__item-info__license d-flex mt-1 "
            >
              {therapistInfo?.therapist_credentials?.toUpperCase().length > 25
                ? therapistInfo?.therapist_credentials
                    ?.toUpperCase()
                    .substr(0, 25) + '...'
                : therapistInfo?.therapist_credentials?.toUpperCase()}
            </Typography>
          </div>

          {therapistInfo?.location_info && (
            <div className="geolocation_distance d-flex mt-1">
              <div>
                <Typography
                  className="fw-semibold"
                  color="color-4"
                  variant="size-14"
                >
                  {therapistInfo.location_info}
                </Typography>
              </div>
              <div>
                {therapistInfo?.distance !== null &&
                  therapistInfo?.distance !== undefined && (
                    <img
                      className="location-icon mb-2 ms-1"
                      src={GroupIcon}
                      alt="GroupIcon"
                    />
                  )}
              </div>
            </div>
          )}
          {/* <Button
                                        variant='secondary'
                                        label='Match with Client'
                                        onClick={() => handleViewTherapistProfile(therapistInfo)}/> */}
        </div>
        <div className="d-flex  position-relative therapists-listCA__item-info__sub-container">
          <div
            className={`d-flex view-details ${
              cardExpand === index ? 'expand' : ''
            }`}
          >
            <div
              className={`therapists-listCA__item-info__specialties ${
                therapistInfo.specialities?.length > 3 ? 'has-more' : ''
              }`}
            >
              <Typography
                variant="size-14"
                color="color-4"
                weight="black"
                className="therapists-listCA__item-info__specialties-title"
              >
                {'EXPERTISE\n'}
              </Typography>
              <div
                className={`therapists-listCA__item-info__specialties-values mt-1 `}
              >
                {therapistInfo.specialities?.map(
                  (specialty: String, i: Number) => (
                    <div key={specialty}>
                      <Typography
                        className={`mt-1 mb-3 ${
                          i === 2 ? 'd-inline-flex' : ''
                        } ${specialty.length > 15 ? 'long-text-value' : ''} ${
                          i === 2 && specialty.length > 12
                            ? 'last-element-adjust'
                            : ''
                        }`}
                      >
                        {`${specialty} `}
                      </Typography>
                      {therapistInfo.specialities.length > 3 && i === 2 && (
                        <Typography
                          className="ms-1 mt-1 d-inline-flex extra-count"
                          weight="semi-bold"
                        >
                          {` + ${therapistInfo.specialities.length - 3}`}
                        </Typography>
                      )}
                    </div>
                  ),
                )}
                {therapistInfo.specialities?.length === 0 && (
                  <Typography className="mt-2">
                    No Specialties available.
                  </Typography>
                )}
              </div>
            </div>
            <div
              className={`therapists-listCA__item-info__specialties ${
                therapistInfo.identities?.length > 3 ? 'has-more' : ''
              }`}
            >
              <Typography
                variant="size-14"
                color="color-4"
                weight="black"
                className="therapists-listCA__item-info__specialties-title"
              >
                {'IDENTITIES\n'}
              </Typography>
              <div
                className={`therapists-listCA__item-info__specialties-values mt-1`}
              >
                {therapistInfo.identities?.map((identity, i) => (
                  <div key={identity}>
                    <Typography
                      className={`mt-1 mb-3 ${i === 2 ? 'd-inline-flex' : ''} ${
                        identity.length > 15 ||
                        (i === 2 && identity.length > 10)
                          ? 'long-text-value'
                          : ''
                      }`}
                    >
                      {`${identity}\n`}
                    </Typography>
                    {therapistInfo.identities?.length > 3 && i === 2 && (
                      <Typography
                        className="ms-1 mt-1 d-inline-flex extra-count"
                        weight="semi-bold"
                      >
                        {` + ${therapistInfo.identities.length - 3}\n`}
                      </Typography>
                    )}
                  </div>
                ))}
                {therapistInfo.identities?.length === 0 && (
                  <Typography>No identity information available</Typography>
                )}
              </div>
            </div>
            <div className={` therapists-listCA__item-info__specialties`}>
              <div>
                <Typography
                  variant="size-14"
                  color="color-4"
                  weight="black"
                  className="therapists-listCA__item-info__specialties-title"
                >
                  {'MEETING AVAILABILITY\n'}
                </Typography>
                <div
                  className={`therapists-listCA__item-info__specialties-values mt-1 d-flex flex-row align-items-center`}
                >
                  {/* {therapistInfo.meeting_availability.map((specialty, i) => */}
                  <div className="d-inline-flex mb-2">
                    {therapistInfo.meeting_availability.length > 0 &&
                      getMeetingAvailabilityGradient(
                        therapistInfo.meeting_availability[0],
                        therapistInfo,
                      ).icons}
                    {therapistInfo.meeting_availability.length > 0 && (
                      <Typography className="mt-2 ">
                        {/* {`${therapistInfo?.meeting_availability}\n`} */}
                        {therapistInfo.meeting_availability.length > 0 &&
                          getMeetingAvailabilityGradient(
                            therapistInfo.meeting_availability[0],
                            therapistInfo,
                          ).label}
                      </Typography>
                    )}
                    {/* )} */}
                  </div>
                  {therapistInfo.meeting_availability.length === 0 ||
                    (therapistInfo.meeting_availability === undefined && (
                      <Typography className={'ms-2 mb-4'}>N/A</Typography>
                    ))}
                </div>
              </div>
              <div
                className={` therapists-listCA__item-info__specialties ${
                  therapistInfo.insurances?.length > 1 ||
                  (therapistInfo.insurances?.length === 1 &&
                    therapistInfo.insurances[0]?.length > 15)
                    ? 'has-more-insurance'
                    : ''
                }`}
              >
                <Typography
                  variant="size-14"
                  color="color-4"
                  weight="black"
                  className="therapists-listCA__item-info__specialties-title"
                >
                  {'INSURANCE\n'}
                </Typography>

                <div
                  className={`therapists-listCA__item-info__specialties-values mt-1 d-flex flex-row align-items-center `}
                >
                  {therapistInfo.insurances?.length !== 0 && (
                    <div
                      className="d-inline-flex  position-relative icon-network"
                      style={{
                        backgroundImage: 'none',
                        height: '30px',
                        width: '30px',
                        borderRadius: '50%',
                        padding: '5px',
                        alignSelf: 'normal',
                        marginTop: '4px',
                      }}
                    >
                      <img src={acceptInsurance} alt="imgAcceptInsurance" />
                    </div>
                  )}

                  <div
                    className={`  ${
                      therapistInfo.insurances?.length === 0
                        ? 'd-none'
                        : 'd-flex d-inline-flex flex-column ms-1 insurance-values justify-content-start'
                    }`}
                  >
                    {therapistInfo.insurances?.map((insurance, i) => (
                      <div
                        key={insurance}
                        className={`d-flex  ${
                          therapistInfo.insurances?.length > 1 && i === 0
                            ? 'custom-width'
                            : ''
                        }`}
                      >
                        <Typography
                          className={`mt-1 mb-3 ${
                            i === 0 ? 'd-inline-flex' : ''
                          } ${
                            insurance.length > 15 ||
                            (i === 2 && insurance.length > 10)
                              ? 'long-text-value'
                              : ''
                          }`}
                        >
                          {`${insurance}\n`}
                        </Typography>
                        {therapistInfo.insurances.length > 1 && i === 0 && (
                          <Typography
                            className="ms-1 mt-1 d-inline-flex extra-count"
                            weight="semi-bold"
                          >
                            {` + ${therapistInfo.insurances.length - 1}\n`}
                          </Typography>
                        )}
                      </div>
                    ))}
                  </div>

                  {therapistInfo.insurances?.length === 0 && (
                    <Typography className={'d-flex ms-4'}>N/A</Typography>
                  )}
                </div>
              </div>
            </div>
            <div className="therapists-listCA__item-info__specialties">
              <div>
                <Typography
                  variant="size-14"
                  color="color-4"
                  weight="black"
                  className="therapists-listCA__item-info__specialties-title"
                >
                  {'CASH-PAY INTAKE FEE\n'}
                </Typography>
                <div
                  className={`therapists-listCA__item-info__specialties-values mt-1`}
                >
                  <Typography className="mt-2 mb-3">
                    ${`${therapistInfo.session_fee}\n`}
                  </Typography>
                  {therapistInfo.session_fee === '' && (
                    <Typography>N/A</Typography>
                  )}
                </div>
                <div>
                  <Typography
                    variant="size-14"
                    color="color-4"
                    weight="black"
                    className="therapists-listCA__item-info__specialties-title mt-3"
                  >
                    {'IN PERSON OFFICE\n'}
                  </Typography>
                  <div
                    className={`therapists-listCA__item-info__specialties-values mt-1`}
                  >
                    <Typography className="mt-2">
                      {`${
                        therapistInfo.therapy_location.length > 0
                          ? therapistInfo.therapy_location[0]
                          : 'Online Only'
                      }\n`}
                    </Typography>
                    {therapistInfo.therapy_location === '' && (
                      <Typography>N/A</Typography>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`d-flex position-relative drawer-arrow align-items-center `}
            onClick={() => handleFlipCard(index)}
          >
            <FontAwesomeIcon
              className={`${cardExpand === index ? 'rotate' : ''}`}
              icon={faPlayCircle}
            />
          </div>
          <div className="availability-container">
            <div
              className={`availability ${
                cardExpand === index ? 'd-none' : 'd-flex'
              } ${
                expandAvailability === index ? 'custom-availability-height' : ''
              }`}
            >
              {therapistInfo?.slots_data?.length === 0 ? (
                <div className="d-flex m-auto justify-content-center">
                  <Typography
                    variant="size-14"
                    weight="semi-bold"
                    color="color-2"
                    className="mb-3"
                  >
                    No Available Slots
                  </Typography>
                </div>
              ) : statusLoading === true &&
                statusLoadingElement === therapistInfo.id ? (
                <div
                  className="d-flex justify-content-center pt-4"
                  style={{
                    width: '100%',
                  }}
                >
                  <Spinner
                    animation="border"
                    role="status"
                    variant="dark"
                    className="ms-5  d-flex"
                  />
                </div>
              ) : therapistInfo.slots_data ? (
                <AvailableSlots
                  practiceTimeZone={practiceTimeZone}
                  availableSlots={therapistInfo.grouped_slot_data || {}}
                  bookAppointmentSlot={slot =>
                    statusLoading === false
                      ? bookAppointmentSlot(slot, therapistInfo)
                      : null
                  }
                />
              ) : (
                <div
                  className="d-flex m-auto cursor-pointer"
                  onClick={() => handleLaterSlot(therapistInfo)}
                >
                  <Typography
                    variant="size-14"
                    color="color-2"
                    weight="bold"
                    className="later_slot"
                  >
                    {isClinicianAvailabilityPage && practiceTimeZone
                      ? `Next opening: ${moment(
                          therapistInfo?.later_slot?.slot_start_date_time,
                        )
                          .tz(practiceTimeZone)
                          .format('ddd, MMM D, hh:mm A')}`
                      : `Next opening: ${moment(
                          therapistInfo?.later_slot?.slot_start_date_time,
                        ).format('ddd, MMM D, hh:mm A')}`}
                  </Typography>
                </div>
              )}
            </div>
            {moreVisible.includes(therapistInfo.therapist_id) && (
              <div
                className={`view-availability cursor-pointer ${
                  cardExpand === index ? 'd-none' : 'd-flex'
                }`}
                onClick={() => handleAvailability(index)}
              >
                <Typography variant="size-12" weight="bold">
                  View More Availability{' '}
                  <FontAwesomeIcon
                    icon={faArrowDownLong}
                    rotation={expandAvailability === index ? 180 : 0}
                  />
                </Typography>
              </div>
            )}
          </div>
        </div>
      </div>

      {therapistInfo?.match_score && (
        <div className="therapists-list__item-percentage">
          <CircularProgressbarWithChildren
            value={therapistInfo?.match_score}
            strokeWidth={9}
            styles={buildStyles({
              strokeLinecap: 'butt',
              pathColor: `#26ECB0`,
              trailColor: '#D4F3EA',
            })}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyItems: 'center',
                alignItems: 'center',
              }}
            >
              <Typography
                variant={`size-36`}
                weight="black"
                className="therapists-list__item-percentage__label"
              >
                <div>{therapistInfo?.match_score}%</div>
              </Typography>
              <Typography variant={`size-12`} weight="bold" color="color-4">
                MATCH
              </Typography>
            </div>
          </CircularProgressbarWithChildren>
        </div>
      )}
    </div>
  );
}
